import { useContext } from 'react';
import { DispatcherVideoContext } from './DispatcherVideoContext';

export function useDispatcherVideoContext() {
  const dispatcherVideoContext = useContext(DispatcherVideoContext);
  if (!dispatcherVideoContext) {
    throw new Error(
      'useDispatcherVideoContext must be used within the DispatcherVideoContext.Provider',
    );
  }
  return dispatcherVideoContext;
}
